import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export const loaderSubject = new BehaviorSubject<{
  loading: boolean;
  message?: string;
}>({ loading: false });

export function withLoader<T>(obs: Observable<T>, message?: string): Observable<T> {
  loaderSubject.next({ loading: true, message });
  return obs.pipe(finalize(() => loaderSubject.next({ loading: false })));
}
